export const SAVED_JOB_STATE_CHANGED_EVENT = "SavedJobStateChanged";

export type SaveButtonSyncState = "SAVED" | "VISITED";

export type SavedJobStateChangedSource = "viewjob" | "jobcard";

export type SavedJobStateChangedEvent = {
  eventType: "SavedJobStateChanged";
  jobKey: string;
  state: SaveButtonSyncState;
  isSaved: boolean;
  source: SavedJobStateChangedSource;
};

export type SavedJobStateChangedSubscription = {
  remove: () => void;
};
